import { Action, LinkActionLinkField } from '@portfolio/models'
import { LinkProps } from 'next/link'
import { Ref } from 'react'
import { ProjectLinkProps } from './types'

export function isActionRef(
  ref: Ref<HTMLAnchorElement | HTMLButtonElement>,
  { action }: { action?: Action },
): ref is Ref<HTMLButtonElement> {
  return !!action
}

export function isHrefRef(
  ref: Ref<HTMLAnchorElement | HTMLButtonElement>,
  { href }: { href?: LinkProps['href'] },
): ref is Ref<HTMLAnchorElement> {
  return !!href
}

export function isLinkAction(
  link: ProjectLinkProps,
): link is LinkActionLinkField {
  return 'action' in link
}

export function isLinkHref(link: ProjectLinkProps): link is { href: string } {
  return 'href' in link && !!link.href
}
